<template>
    <div class="attach-container">
        <div v-if="route.query.redirect" class="back-route" @click="router.back()"><i class="material-icons">keyboard_arrow_left</i>Volver</div>
        <div v-else class="back-route" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}`)"><i class="material-icons">keyboard_arrow_left</i><span>Volver al módulo</span></div>
        <!-- <h2>{{$t('global.ACTIVITY')}} <span v-if="contentLoaded">{{ $t('global.DELIVERY_DATE') }} {{content.displayEndDate}}</span></h2> -->


        <div class="module_muro__title">
            <span class="module_muro__title-activity">{{$t('global.ACTIVITY')}}</span>
            <p v-if="contentLoaded" class="module_muro__title-date">
                <span
                v-if="content && content.isMandatory"
                ><i class="material-icons-outlined">error</i> {{ $t('attach.MANDATORY_ACTIVITY') }}</span>
                <span
                v-else
                ><i class="material-icons-outlined">error</i> {{ $t('attach.OPTIONAL_ACTIVITY') }}</span>
                <span v-if="content.displayEndDate">{{ $t('global.DELIVERY_DATE') }} {{content.displayEndDate}}</span>
            </p>
        </div>

        <div v-if="contentLoaded" class="content">
            <div v-html="content.data.Data"></div>
        </div>
        <div v-else-if="!contentLoaded && !moduleLocked">{{$t('activity.LOAD_CONTENT')}}</div>

        <EmptyState v-if="moduleLocked" :icon="'event'" :title="$t('attach.CONTENT_NOT_AVAILABLE')" :message="$t('attach.CONTENT_AVAILABLE_MESSAGE', { date: moduleLockedDate })" :color="'pink'"/>


        <template v-if="user.permissions.includes('ACTIVIDAD_COMPLETAR')">
            <template v-if="attachesLoaded">
                <!-- <div class="activity-done" v-if="(attaches.hasAttaches && !content.courseIsFinished)"> -->
                <div class="activity-done" 
                v-if="(attaches.hasAttaches && !content.courseIsFinished || initialAnswer && !content.courseIsFinished)">
                <div><i class="material-icons">check_circle</i></div>
                    <div>
                        <div class="activity-done__title">{{ $t('activity.status.done.TITLE') }}</div>
                        <div class="activity-done__info">{{ $t('activity.status.done.INFO') }}</div>
                    </div>
                </div>
                <!-- <div class="activity-pending" v-if="(!attaches.hasAttaches && !content.courseIsFinished)"> -->
                <div class="activity-pending" 
                v-if="(!attaches.hasAttaches && !initialAnswer && !content.courseIsFinished)">
                <div><i class="material-icons">info</i></div>
                    <div>
                        <div class="activity-pending__title">{{$t('activity.status.pending.TITLE')}}</div>
                        <div class="activity-pending__info">{{$t('activity.status.pending.INFO')}}</div>
                    </div>
                </div>
                <div v-if="content.courseIsFinished" class="courseIsFinished">
                    <i class="material-icons">check_circle</i>
                    <span>
                        <strong>{{$t('activity.status.finished.TITLE')}}</strong><br/>
                        <p>{{$t('activity.status.finished.INFO')}}</p>
                    </span>
                </div>
                <div class="attaches">
                    <template v-if="attaches.attach.length">
                        <div class="attaches__title">{{ $t('file.UPLOADED_FILES')}}</div>
                        <div class="attaches__container">
                            <div class="attach" v-for="(file,index) in attaches.attach" :key="index">
                                <a :href="getFile(file.file,'activity')" target="_bank">{{file.originalFileName}}</a>
                                <i v-if="!content.courseIsFinished" class="material-icons" @click.stop="removeFileIdx = index; customModal.active = 'removeFile'">close</i>
                            </div>
                        </div>
                    </template>
                    <EmptyState v-if="(!attaches.attach.length && !attaches.hasPreviousRecords && !content.courseIsFinished)" 
                        :icon="'cloud_upload'" 
                        :title="$t('file.emptyState.TITLE')" 
                        :message="$t('file.emptyState.TITLE')" 
                        :subMessage="$t('file.MAX_FILE_WEIGHT')" 
                        :uploadFileView="true"
                        @uploadFile="uploadFile"
                    />
                </div>

                <!-- include new-feedback type textearea -->
                <!-- <div class="history__form" v-if="detail.expand && user.permissions.includes('CURSO_ACTIVIDAD_FEEDBACK_CREACION')"> -->
                <!-- <div class="attach-text">
                    <div class="attach-text__textarea">
                        <textarea v-model="attaches.answer" placeholder="Escribe una respuesta..."></textarea>
                    </div>
                </div> -->

                <div class="attach-text" v-if="!content.courseIsFinished">
                    <div class="attach-text__textarea">
                        <textarea 
                        v-model="attaches.answer" 
                        :placeholder="$t('attach.WRITE_AN_ANSWER')" 
                        @input="limitCharacters($event)"
                        ></textarea>
                        <div 
                        class="characters-count" 
                        :style="{'color': (maxCharacters - attaches?.answer?.length) < 0 ? '#F57055' : ''}"
                        >
                        <!-- {{ maxCharacters - (attaches?.answer?.length || 0) }} caracteres restantes -->
                        {{ $t('attach.REMAINING_CHARACTERS', { count: maxCharacters - (attaches?.answer?.length || 0) }) }}

                        </div>
                    </div>
                </div>



                <div class="attach__actions">
                    <div class="attach__actions--container">
                        <template v-if="attaches.attach.length || (!attaches.attach.length && attaches.hasPreviousRecords)">
                            <div @change="uploadFile($event)" class="upload-file__container">
                                <label :class="content.courseIsFinished && 'disabled'" for="upload-file">
                                    {{ !attaches.attach.length ? $t('attach.UPLOAD_A_FILE') : $t('attach.UPLOAD_ANOTHER_FILE') }}
                                    <i class="material-icons">file_upload</i>
                                </label>
                                <input :disabled="content.courseIsFinished" type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                            </div>
                            <button v-if="!content.courseIsFinished" @click.stop="showPopUp = !showPopUp" @mouseover="!isMobile && setPopUpHover(true)" @mouseleave="!isMobile && setPopUpHover(false)"  >
                            <i class="material-icons-outlined" >info</i>
                            </button>
                            <HoverPopUp v-if="showPopUp" :content="$t('file.MAX_FILE_WEIGHT')" />
                        </template>
                    </div>

                    <div class="confirm-edition">
                        <button class="btn-cancel" :disabled="!hasChanges" @click.stop="customModal.active = 'discardChanges'">
                            {{$t('global.CANCEL')}}    
                        </button>
                        <!-- <button class="btn-confirm" :disabled="!hasChanges || attaches.fileUploading || (!attaches.attach.length && !attaches.hasAttaches)" 
                        @click.stop="customModal.active = !attaches.attach.length && attaches.hasAttaches ? 'deleteActivity' : attaches.hasAttaches ? 'confirmChanges' : 'sendActivity'" 
                        :class="{'sendAttach--effect': hasChanges}" >
                            <span>Continuar</span><i class="material-icons">arrow_forward</i>
                        </button> -->
                        <button class="btn-confirm" :disabled="!hasChanges || attaches.fileUploading" 
                        @click.stop="customModal.active = !attaches.attach.length && !attaches.answer && attaches.hasAttaches || !attaches.attach.length && !attaches.answer && initialAnswer || !attaches.attach.length && !attaches.answer ? 'deleteActivity' : attaches.hasAttaches || initialAnswer ? 'confirmChanges' : 'sendActivity'" 
                        :class="{'sendAttach--effect': hasChanges}" >
                            <span>{{ $t('global.CONTINUE') }}</span><i class="material-icons">arrow_forward</i>
                        </button>



                    </div>

                </div>
                 
                <div class="feedback" v-if="attaches.feedback">
                    <h4>{{ $t('activity.LAST_RETURN') }}</h4>
                    <div class="feedback__tutor-data">
                        <span>{{$t('role.TUTOR')}}: {{attaches.feedback.teacherName}} - </span>
                        <span>{{formatDate(attaches.feedback.correctionDate)}}</span>
                    </div>
                    <div v-html="attaches.feedback.message" class="feedback__message"></div>
                </div>

                <div class="feedback__history">
                    <button v-if="user.value?.permissions.includes('CURSO_ACTIVIDAD_DETALLE')" class="feedback__history--btn" @click.stop="router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/activity/attach/${route.params.contentId}/userHistory/${user.id}`)" >{{ $t('attach.VIEW_FEEDBACK_HISTORY') }}</button>
                </div>

            </template>

            <template v-if="customModal.active">
                <VisibleModal />
                <div class="modal__overlay">
                    <div class="custom-modal">
                        <i class="material-icons-outlined" v-if="customModal[customModal.active].icon" 
                        :class="{'uploadFile-icon' : customModal.active == 'fileUploading'}" :style="[customModal.active == 'errorFile' ? {'color': 'red'} : '']"> 
                        {{customModal[customModal.active].icon}}</i>
                        <div class="title"><div v-html="customModal[customModal.active].title"></div></div>
                        <div class="info"><div v-html="customModal[customModal.active].info"></div></div>
                        <div v-if="customModal.active === 'fileUploading'" class="bar"></div>
                        <div class="buttons" v-if="customModal.active !== 'fileUploading'">
                            <template v-if="customModal.active == 'sendActivity'">
                                <button @click.stop="customModal.active = null" :disabled="customModal.disableBtns" :style="{color: '#009696'}">{{$t('global.CANCEL')}}</button>
                                <button @click.stop="saveChanges()" :disabled="customModal.disableBtns" :style="{backgroundColor: '#009696', color: '#fff'}">{{ $t('activity.CONFIRM_DELIVERY')}}</button>
                            </template>
                            <template v-if="customModal.active == 'confirmChanges'">
                                <button @click.stop="customModal.active = null" :disabled="customModal.disableBtns" :style="{color: '#009696'}">{{$t('global.CANCEL')}}</button>
                                <button @click.stop="saveChanges()" :disabled="customModal.disableBtns" :style="{backgroundColor: '#009696', color: '#fff'}">{{$t('global.SAVE_CHANGES')}}</button>
                            </template>
                            <template v-if="customModal.active == 'discardChanges'">
                                <button @click.stop="customModal.active = null" :disabled="customModal.disableBtns" :style="{color: '#009696'}">{{ $t('global.CONTINUE_EDITING')}}</button>
                                <button @click.stop="router.go()" :disabled="customModal.disableBtns" :style="{backgroundColor: '#009696', color: '#fff'}">{{ $t('activity.DISCARD_CHANGES') }}</button>
                            </template>
                            <template v-if="customModal.active == 'deleteActivity'">
                                <button @click.stop="customModal.active = null" :disabled="customModal.disableBtns" :style="{color: '#212121'}">{{$t('global.CANCEL')}}</button>
                                <button @click.stop="saveChanges(); getAttaches()" :disabled="customModal.disableBtns" :style="{backgroundColor: '#F57055', color: '#fff'}">{{ $t('activity.DELETE_DELIVERY')}}</button>
                            </template>
                            <template v-if="customModal.active == 'removeFile'">
                                <button @click.stop="customModal.active = null; removeFileIdx=null" :disabled="customModal.disableBtns" :style="{color: '#212121'}">{{$t('global.CANCEL')}}</button>
                                <button @click.stop="removeFile()" :disabled="customModal.disableBtns" :style="{backgroundColor: '#F57055', color: '#fff'}">{{ $t('file.DELETE_FILE')}}</button>
                            </template>
                            <div @change="uploadFile($event)" class="upload-file__container" v-if="customModal.active == 'errorFile'">
                                <label for="upload-file">{{ $t('attach.UPLOAD_ANOTHER_FILE') }}<i class="material-icons">file_upload</i></label>
                                <input type="file" accept=".doc,.docx,.ppt,.pptm,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.xls,.xlsx" name="attach" id="upload-file">
                            </div>
                        </div>
                    </div>
                </div>
            </template>


            <template v-if="modalStudentsQty">
            <VisibleModal />
            <div class="modal__overlay">
                <div class="custom-modal modal--modalStudentsQty">
                    <div class="title">{{ $t('attach.STUDENTS_QTY_TITLE') }}</div>
                    <div class="info">{{ $t('attach.STUDENTS_QTY_INFO') }}</div>
                    <Input
                        v-model="finalPracticeStudentsQty"
                        type="number"
                        :placeholder="$t('attach.STUDENTS_QTY')"
                        :label="$t('attach.STUDENTS_QTY')"
                    />
                    <div class="buttons">
                        <!-- <button class="cancel" @click.stop="modalStudentsQty = false">Cancelar</button> -->
                        <button class="confirm" :disabled="loadingModalStudentsQty || !finalPracticeStudentsQty" @click.stop="submitFinalPracticeStudentsQty()">{{ $t('global.CONFIRM') }}</button>
                    </div>
                </div>
            </div>
            <!-- <Input v-model="finalPracticeStudentsQty"/> -->
        </template>
            
        </template>

        <div class="tutor-view" v-else>

            <template v-if="resumeLoaded && user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
                <div class="resume">
                    <div class="title" @click.stop="resume.expand ? resume.expand = false : resume.expand = true">
                        <div class="title__span">
                            <span>{{$t('global.RESUME')}}</span>
                            <i class="material-icons">{{resume.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
                        </div>
                    </div>
                    <div class="resume-data" v-if="resume.expand">
                        <div>{{ $t('global.PARTICIPANT')}}: <span>{{resume.totalStudents}}</span></div>
                        <div>{{ $t('global.TOTAL_DELIVERED')}}: <span>{{resume.finished}}</span></div>
                        <div>{{ $t('global.DELIVERY_DATE') }}: <span>{{formatDate(resume.endDate)}}</span></div>
                        <div>{{ $t('global.ACTIVITY_STATUS')}} : 
                            <span v-if="resume.remainingTimeValue" style="color:#009696" >{{$t('global.OPEN')}}</span>
                            <span v-else style="color:#F57055">{{ $t('global.OVERDUE')}}</span>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="detailLoaded && user.permissions.includes('CURSO_ACTIVIDAD_AVANCE')">
                <div class="detail">
                    <div class="title">
                        <div class="title__span" @click.stop="detail.expand = !detail.expand" >
                            <span>{{$t('global.DETAIL')}}</span>
                            <i class="material-icons">{{detail.expand ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i>
                        </div>
                        <div v-show="detail.expand" class="details__filter" >
                             <div  class="dropdown" ref="status">
                                <input type="checkbox" id="status">
                                <label class="dropdown__face" for="status">
                                    <div class="dropdown__text">{{$t('global.STATE')}}</div>
                                    <span class="material-icons">keyboard_arrow_down</span>
                                </label>
                                <ul class="dropdown__items">
                                    <template v-for="(state,index) in statusFilters.status" :key="index" >
                                        <li :style="{ 'color': statusFilters.selected === state ? '#000' : '#7D7D7D' }" @click.stop="addStateFilter(state)" >{{ $t(`tutor.detail.status.${state}`) }}</li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="detail-data" v-if="detail.expand">
                        <div><input type="checkbox" v-model="allStudentsChecked" @click.stop="toggleAllChecks()"></div>
                        <div class="table-title">{{$t('global.PARTICIPANT')}}</div>
                        <div class="table-title">{{$t('global.STATE')}}</div>
                        <div class="table-title">{{$t('global.RETURN')}}</div>                
                        <div class="table-title">{{$t('global.LAST_MODIFICATION')}}</div>
                        <template v-if="detailValuesLoaded" >
                            <template v-for="(student,index) in detail.data" :key="index">
                                <div><input type="checkbox" v-model="student.checked" @click.stop="updateFeedbackChecks()"></div>
                                <div class="table-user" @click.stop="user.permissions.includes('CURSO_ACTIVIDAD_DETALLE') && router.push(`/course/${route.params.courseId}/module/${route.params.moduleId}/activity/attach/${route.params.contentId}/userHistory/${student.learningUserId}`)">
                                    {{student.firstName}} {{student.lastName}}
                                </div>
                                <div class="detail__status">
                                    <span :class="{'NotFinished--a': student.status == 'NotFinished', 'FinishedOutOfTime--a': student.status === 'FinishedOutOfTime', 'FinishedInTime--a': student.status === 'FinishedInTime'}">
                                        {{$t(`tutor.detail.status.${student.status}`)}}
                                    </span>
                                    <span v-if="student.status == 'NotFinished'">
                                        {{student.timeDiffValue ? $t('global.EXPIRES_IN') + student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) : $t('global.EXPIRED')}}
                                    </span>
                                    <span v-if="student.status == 'FinishedOutOfTime'">
                                        {{student.timeDiffValue + ' ' + $t(`date.params.${student.timeDiffParam}`) + + ' ' + $t('global.LATE')}}
                                    </span>
                                </div>
                                <div class="detail__answered" :style="{'color': student.hasFeedback ? '#009696' : '#F57055'}" >
                                    {{ student.hasFeedback ? $t('attach.SENT') : $t('attach.NOT_SENT') }}
                                </div>
                                <div class="detail__lastModification">{{student.lastSeen ? formatDate(student.lastSeen) : $t('global.NEVER')}}</div>
                            </template>
                        </template>
                        <template v-else >
                            <Skeletor class="table-user" width="100%" />
                            <Skeletor class="detail__status" width="100%"></Skeletor>
                            <Skeletor class="detail__status" width="80%"></Skeletor>
                            <Skeletor class="detail__status" width="60%"></Skeletor>
                            <Skeletor class="detail__status" width="60%"></Skeletor>
                        </template>
                    </div>
                    <div class="history__form" v-if="detail.expand && user.permissions.includes('CURSO_ACTIVIDAD_FEEDBACK_CREACION')">
                        <div class="new-feedback">
                            <textarea v-model="feedbackModel.message" placeholder="Escribe una devolución..."></textarea>
                            <div class="new-feedback__actions">
                                <button class="cancel" @click.stop="feedbackModel.message = ''">{{$t('global.CANCEL')}}</button>
                                <button class="confirm" :disabled="!feedbackModel.message || !feedbackModel.learningUsers.length" @click.stop="modalConfirmFeedback = true">{{ $t('global.SEND') }} <i class="material-icons-outlined">arrow_forward</i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </template> <!-- /tutor detail -->

            <template v-if="modalConfirmFeedback">
                <VisibleModal />
                <div class="modal__overlay" @click.stop="modalConfirmFeedback = false">
                    <div class="modal">
                        <p class="text">{{ $t('attach.CONFIRM_SEND_FEEDBACK', { count: feedbackModel.learningUsers.length }) }}</p>
                        <div class="modal__buttons">
                            <button class="cancel" @click.stop="modalConfirmFeedback = false">{{$t('global.CANCEL')}}</button>
                            <button class="confirm" :disabled="sendingFeedback" @click.stop="sendFeedback()">{{$t('global.CONFIRM')}}</button>
                        </div>
                    </div>
                </div>
            </template>


        </div> <!-- /tutor-view -->

    </div>
</template>

<script>
import { useRouter ,useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import storage from "@/plugins/azure-storage";
import { inject, computed } from "@vue/runtime-core";
import { onClickOutside } from '@vueuse/core';
import VisibleModal from '@/components/VisibleModal.vue';
import { Skeletor } from 'vue-skeletor'; 
import EmptyState from '../../components/EmptyState.vue';
import HoverPopUp from '../../components/HoverPopUp.vue';
import { useI18n } from 'vue-i18n';
import Input from '@/components/Input.vue';
//import Loader from '../../components/Loader.vue'



export default {
    components:{
    VisibleModal,
    Skeletor,
    EmptyState,
    HoverPopUp,
    Input,
    //Loader
},

    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const formatDate = inject("formatDate");
        const isMobile = inject('mobileVersion');
        const user = computed(() => store.getters.manageUser_user);
        const getFile = inject("getFile");
        const content = ref();
        const contentLoaded = ref(false);
        const moduleLocked = ref(false);
        const moduleLockedDate = ref('');
        const attaches = ref();
        const attachesLoaded = ref(false);
        const resume = ref();
        const resumeLoaded = ref(false);
        const detail = ref({
            expand: false,
            data: []
        });
        const detailLoaded = ref(false);
        const detailValuesLoaded = ref(false)
        const removeFileIdx = ref(null);
        const hasChanges = ref(false);
        const { t } = useI18n()
        const customModal = ref({
            active: null,
            disableBtns: false,
            sendActivity: {
                icon: null,
                title: t('activity.sendActivity.TITLE'),
                info: t('activity.sendActivity.INFO')
            },
            confirmChanges: {
                icon: null,
                title: t('activity.confirmChanges.TITLE'),
                info: t('activity.confirmChanges.INFO')
            },
            discardChanges: {
                icon: null,
                title: t('activity.discardChanges.TITLE'),
                info: t('activity.confirmChanges.INFO')
            },
            deleteActivity: {
                icon: null,
                title: t('activity.deleteActivity.TITLE'),
                info: t('activity.deleteActivity.INFO')
            },
            fileUploading: {
                icon: 'cloud_upload',
                title: t('activity.fileUploading.TITLE'),
                info: t('activity.fileUploading.INFO')
            },
            removeFile: {
                icon: null,
                title: t('activity.removeFile.TITLE'),
                info: t('activity.removeFile.INFO')
            },
            errorFile: {
                icon: 'cancel',
                title: t('activity.errorFile.TITLE'),
                info: t('activity.errorFile.INFO')
            }
        })



        const maxCharacters = 3000; // Define your character limit

        // Function to prevent typing beyond the limit
        function limitCharacters(event) {
            hasChanges.value = true; // Activar cambios cuando el usuario escribe
            if (attaches.value.answer.length >= maxCharacters) event.preventDefault();
        }

        const showPopUp = ref(false)
        const statusFilters = ref({
            status: ['All'],
            selected: 'All'
        })
        const status = ref(null);

        /* Tutor send feedback */
        const feedbackModel = ref({
            contentId: route.params.contentId,
            learningUsers: [],
            message: ''
        })
        const allStudentsChecked = ref(false);
        const modalConfirmFeedback = ref(false);

        // studentsQty
        const finalPracticeStudentsQty = ref(null);
        const modalStudentsQty = ref(false);
        const loadingModalStudentsQty = ref(false);
        
        const sendingFeedback = ref(false);

        const setPopUpHover = value => showPopUp.value = value

        function updateFeedbackChecks(){
            feedbackModel.value.learningUsers = [];
            setTimeout(()=>{
                detail.value.data.forEach(student =>{
                    if(student.checked) feedbackModel.value.learningUsers.push(student.learningUserId);
                })
                if(!feedbackModel.value.learningUsers.length) { allStudentsChecked.value = false }
                if(feedbackModel.value.learningUsers.length == detail.value.data.length) { allStudentsChecked.value = true }
            },0)
        }

        function toggleAllChecks(){
            setTimeout(()=>{ detail.value.data.forEach(student => student.checked = allStudentsChecked.value) },0)
            updateFeedbackChecks();
        }

        async function sendFeedback(){
            sendingFeedback.value = true;
            try {
                await store.dispatch('activities_attachManyFeedback',feedbackModel.value);
                modalConfirmFeedback.value = false;
                store.dispatch('notifications_create', { text: t('activity.feedback.SENT_CORRECTLY')});
                detail.value.data.forEach(student => student.checked = false);
                feedbackModel.value.learningUsers = [];
                feedbackModel.value.message = '';
                allStudentsChecked.value = false;
            } catch (error) {
                console.log(error)
                store.dispatch('notifications_create', { text: t('activity.feedback.ERROR')})
            }
            sendingFeedback.value = false;
        }

        async function uploadFile(event){
            let file = event.target.files[0];
            if(!file) return;
            let fileAccepted = ['application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/vnd.ms-powerpoint','application/vnd.ms-powerpoint.presentation.macroEnabled.12','application/vnd.openxmlformats-officedocument.presentationml.presentation','application/pdf','image/png','image/jpeg','image/gif','application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
            let fileIsOk = false
            for (let ext of fileAccepted){
                if(ext === file.type){
                  fileIsOk = true;
                  break;
                } 
            }
            if (file.size > 629145600 || !fileIsOk){
                customModal.value.active = 'errorFile';
                return;
            }
            attaches.value.fileUploading = true;
            customModal.value.active = 'fileUploading';
            try {
                let fileCDN = await storage.updateFile(file,'activity');
                attaches.value.attach.push({file: fileCDN, originalFileName: file.name});
                hasChanges.value = true;
            } catch (error){
                console.log(error);
                store.dispatch('notifications_create',{text:t('file.uploading_error.ERROR')});
            } finally{
                attaches.value.fileUploading = false;
                customModal.value.active = null;
            }
        }

        async function saveChanges(){
            customModal.value.disableBtns = true;
            try {
                attaches.value.contentId = route.params.contentId;
                await store.dispatch('activities_updateAttaches',attaches.value);
                customModal.value.active = null;
                //store.dispatch('notifications_create',{text:'Archivos actualizados correctamente'});
                hasChanges.value = false;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('activity.ERROR_CONFIRM')})
            } finally {
                getAttaches()       
                customModal.value.disableBtns = false;

                // ask if students qty is needed, if so, show modal
                // see if attached files are empty, also if query param is ?sQty=true
                if (attaches.value.attach.length !== 0 && route.query.sQty === 'true') {
                    let studentsQtyModalVisibleData = await getStudentsQtyModalVisible();
                    if (!studentsQtyModalVisibleData.isComplete) {
                        modalStudentsQty.value = true;
                    }
                }
                
            }
        }
        
        
        async function removeFile(){
            customModal.value.active = null;
            try {
                attaches.value.attach.splice(removeFileIdx.value, 1);
                hasChanges.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('activity.ERROR_DELETE_FILE')});
            } finally{
                removeFileIdx.value = null;
            }
        }


        const initialAnswer = ref('');

        async function getAttaches(){
            try {
                let req = await store.dispatch('activities_attaches',route.params.contentId);
                attaches.value = req.data;
                attachesLoaded.value = true;
                initialAnswer.value = attaches.value.answer;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('activity.ERROR_GET_FILES')});
            }
        }

        async function getStudentsQtyModalVisible() {
            try {
                let req = await store.dispatch('activities_finalPracticeStudentsQty', route.params.courseId);
                // finalPracticeStudentsQty.value = req.data;
                return req.data;
            } catch (error) {
                console.log(error);
            }
        }

        async function submitFinalPracticeStudentsQty() {
            loadingModalStudentsQty.value = true;
            try {
                await store.dispatch('activities_finalPracticeStudentsQtyUpdate', { courseId: route.params.courseId, qty: finalPracticeStudentsQty.value });
                store.dispatch('notifications_create', { text: t('attach.STUDENTS_QTY_UPDATED_SUCCESS') });
                modalStudentsQty.value = false;
                // clean up
                finalPracticeStudentsQty.value = null;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('attach.STUDENTS_QTY_UPDATED_ERROR') });
            }
            loadingModalStudentsQty.value = false;
        }


        // const initialDeliveryStatus = computed(() => {
        //     return attaches.value.attach.length > 0 || (attaches.value.hasAttaches && initialAnswer.value && initialAnswer.value.trim().length > 0);
        // });

        /* TUTOR */
        async function getResume(){
            try {
                let req = await store.dispatch('activities_tutorResume',route.params.contentId);
                resume.value = req.data;
                resume.value.expand = true;
                resumeLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('activity.ERROR_LOAD_SUMMARY')});
            }
        }

        async function getDetail(){
            let prop = {
                contentId: route.params.contentId,
                status: statusFilters.value.selected
            }
            try {
                detailValuesLoaded.value = false
                let req = await store.dispatch('activities_tutorDetail',prop);
                detail.value.data = req.data;
                detailValuesLoaded.value = true
                detailLoaded.value = true;
            } catch (error) {
                console.log(error);
                store.dispatch('notifications_create', { text: t('activity.ERROR_LOAD_DETAIL')});
            }
        }

        const getStatus = async () => {
            let res = await store.dispatch('activities_submissionsFilters')
            statusFilters.value.status.push(...res.data)
        }

        const addStateFilter = (state) => {
            statusFilters.value.selected = state
            document.getElementById('status').checked = false
            getDetail()
        }

        function tutorReq(){
            getResume();
            getDetail();
        }

        onClickOutside(status, () => document.getElementById('status').checked = false)

        onMounted(async()=>{
            // let reqContent = await store.dispatch('courses_contents',route.params.contentId);
            // content.value = reqContent.data;
            // if(error.response.data.includes('Module is not open')){
            //     moduleLockedDate.value = error.response.data.split('_')[1].split(' ')[0];
            //     moduleLocked.value = true;
            // }
            // make request try catch
            try {
                let reqContent = await store.dispatch('courses_contents',route.params.contentId);
                content.value = reqContent.data;
                content.value.data = JSON.parse(content.value.data);
                content.value.data.Data = content.value.data.Data.replace(/\[BEGIN_(\w*)\]?/g,'').replace(/\[END_(\w*)\]?/g,'');
                contentLoaded.value = true;
                user.value.permissions.includes('CURSO_ACTIVIDAD_AVANCE') ? tutorReq() : getAttaches();
                getStatus()
                
            } catch (error) {
                // alert('error')
                if(error.response.data.includes('Content is not open')){
                    moduleLockedDate.value = error.response.data.split('_')[1].split(' ')[0];
                    moduleLocked.value = true;
                }
            }


            
        })

        return{
            router,
            route,
            formatDate,
            content,
            attaches,
            contentLoaded,
            attachesLoaded,
            uploadFile,
            removeFile,
            removeFileIdx,
            getFile,
            user,
            resume,
            resumeLoaded,
            detail,
            detailLoaded,
            hasChanges,
            saveChanges,
            statusFilters,
            addStateFilter,
            status,
            detailValuesLoaded,
            feedbackModel,
            toggleAllChecks,
            allStudentsChecked,
            updateFeedbackChecks,
            sendFeedback,
            modalConfirmFeedback,
            showPopUp,
            isMobile,
            setPopUpHover,
            customModal,
            moduleLocked,
            moduleLockedDate,
            finalPracticeStudentsQty,
            modalStudentsQty,
            loadingModalStudentsQty,
            getStudentsQtyModalVisible,
            submitFinalPracticeStudentsQty,
            maxCharacters,
            limitCharacters,
            // initialDeliveryStatus
            initialAnswer,
            sendingFeedback,
            t
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.hover__container{
    position: absolute;
    left: 17%;
    bottom: 90%;
    @media screen and (max-width: $bpMedium){
        left: 9%;
        bottom: 105%;
    }
}

.bar{
    margin-top: 14px;
    margin-left: 25%;
    margin-right: 25%;
    width: 0%;
    height: 4px;
    background  : linear-gradient(270deg, #009696 0%, #DDDDDD 100%);
    border-radius: 999px;
    align-self: flex-start;
    animation: uploading 3s infinite ease-in;
    @keyframes uploading{
        0%{
            width: 0%;
        }
        50%{
            width: 50%;
        }
        100%{
            width: 0%;
        }
    }
}

.back-route{
    width: fit-content;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 1px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

h2{
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    font-size: 24px;
    line-height: 24px;
    span{
        font-size: 13px;
        line-height: 13px;
        color: $black;
    }
}

.content{
    margin: 8px 0 24px 0;
    font-size: 18px !important;
    *{
        font-size: 18px !important;
    }
}

.attach__date{
    font-size: 14px;
}

.activity{
    &-done,&-pending{
        padding: 14px;
        display: flex;
        align-items: stretch;
        >div{
            display: flex;
            flex-direction: column;
            &:first-child{
                width: fit-content;
                .material-icons{
                    padding-right: 6px;
                }
            }
            &:last-child{
                flex-grow: 1;
                gap: 12px;
                font-size: 14px;
            }
        }
        &__title{
            padding-top: 2px;
            font-weight: 700;
        }
        &__info{
            font-weight: 500;
        }
    }
    &-done{
        background-color: map-get($primary, onMediumEmphasis);
        &__title,.material-icons{
            color: $green;
        }
    }
    &-pending{
        background: rgba(255, 189, 176, 0.5);
        &__title,.material-icons{
            color: map-get($secondary, 500);
        }
    }
}

.attaches{
    margin: 16px 0 26px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 14px;
    &__title{
        color: $green;
        font-weight: 600;
    }

    .attaches__container{
        display: flex;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 18px;
        .attach{
            padding: 8px 12px;
            display: flex;
            align-items: center;
            gap: 20px;
            border: 1px solid $black;
            border-radius: 44px;
            color: $black;
            font-size: 13px;
            font-weight: 500;
            width: fit-content;
            cursor: pointer;
            .material-icons{
                color: #333;
                font-size: 14px;
                line-height: 18px;
                font-weight: 600;
            }
        }
    }
}

// styles like history form new-feedback
.attach-text {
    // textarea {
    // width: 100%;
    // height: 80px;
    // min-height: 80px;
    // padding: 6px;
    // resize: vertical;
    // border-radius: 4px;

    //     @media(max-width:980px) {
    //         height: 200px;
    //         min-height: 200px;
    //     }
    // }
    textarea{
        width: 100%;
        height: 300px;
        margin: 22px 0 0px 0;
        padding: 8px 28px;
        resize: none;
        background-color: #F6F6F6;
        border: none;
        outline: none;
        border-radius: 10px;
        &::placeholder{
            color: $green;
            font-weight: 600;
        }
    }
    .characters-count{
        margin-bottom: 10px;
        display: flex;
        justify-content: flex-end;
        font-size: 11px;
        font-weight: 400;
        font-style: italic;
        color: #515151;
    }
}

.attach__actions {
    position: relative;
    margin-top: 24px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    &--container{
        display: flex;
        align-items: center;
        gap: 6px;
        .material-icons-outlined{
            line-height: 36px;
            color: $green;
        }
    }
    .confirm-edition{
        display: flex;
        gap: 20px;
        button{
            font-size: 14px;
            font-weight: 600;
            cursor: pointer;
            &:disabled{
                opacity: .6;
                cursor: default;
            }
        }
        .btn-cancel{
            color: $green;
        }
        .btn-confirm{
            display: flex;
            gap: 6px;
            justify-content: center;
            align-items: center;
            height: 38px;
            width: 166px;
            background-color: $green;
            border-radius: 44px;
            color: #fff;
            box-shadow: 0px 8px 15px rgba(0, 0, 0, 0.1);
            overflow: hidden;
        }
    }
}

.upload-file__container{
    display: inline-block;
    position: relative;
    left: 0;
    text-align: center;
    #upload-file{
        visibility: hidden;
        position: absolute;
        width: 0px;
        height: 0px;
        top: 0;
        left: 0;
    }
    label,span{
        height: 36px;
        width: 181px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        border: 1px solid $green;
        background: #fff;
        border-radius: 44px;
        color: $green;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        .material-icons{
            color: $green;
            font-size: 19px;
        }
    }
}

.custom-modal{
    width: 98%;
    max-width: 560px;
    padding: 32px;
    @include flex-column;
    gap: 10px;
    background: #fff;
    border-radius: 10px;
    color: $black;
    text-align: center;
    .title{
        font-weight: 700;
        font-size: 18px;
    }
    .info{
        font-weight: 400;
        font-size: 14px;
    }
    .buttons{
        width: fit-content;
        padding: 10px 0;
        display: flex;
        gap: 18px;
        button{
            padding: 10px 16px;
            border-radius: 44px;
            font-size: 16px;
            font-weight: 600;

            &.confirm {
                background: $green;
                color: #fff;
            }

            &:disabled{
                opacity: .5;
            }
        }
    }

}

.info-changes{
    margin-top: 32px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    font-weight: 500;
    .material-icons{
        font-size: 18px;
    }
}

.feedback{
    margin-top: 32px;
    padding: 12px;        
    background: #F5F5F5;
    border-radius: 8px;
    h4{
        color: $green;
        margin-bottom: 8px;
    }
    &__tutor-data{
        margin-bottom: 5px;
        font-size: 13px;
        font-weight: 600;
        span:last-child{
            font-size: 11px;
        }
    }
    &__message{
        font-size: 14px;
        color: #918f8f;
    }
}

.feedback__history{
    width: 100%;
    margin-top: 16px;
    display: flex;
    justify-content: center;
    .feedback__history--btn{
        padding: 12px;
        background:  $black;
        color: #ffF;
        border-radius: 99px;
        font-weight: bold;
        font-size: 12px;
    }
}

.tutor-view{
    .title{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 4px;
        color: $green;
        font-size: 16px;
        font-weight: 700;
        cursor: pointer;
        &__span{
            display: flex;
            align-items: center;
        }
    }
    .resume,.detail{
        &-data{
            padding: 16px;
            margin-top: 12px;
            background: inherit;
            box-shadow: 0px 4px 4px #00000040;
            border-radius: 8px;
        }
    }
    .resume{
        margin-bottom: 24px;
        &-data{
            display: grid;
            grid-template-columns: auto auto;
            gap: 16px;
            color: #000;
            font-weight: 600;
            font-size: 14px;
            @media screen and (max-width: $bpSmall){
                font-size: 12px;
            }
            span{
                font-weight: 400;
                margin-left: 6px;
            }
        }
    }
    .detail{
        &-data{
            width: 100%;
            display: grid;
            grid-template-columns: 30px auto auto auto auto;
            gap: 16px;
            overflow-x: auto;
            >div{
                @include flex-column;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                font-size: 14px;
                margin-bottom: 10px;
                @media screen and (max-width: $bpSmall){
                    font-size: 12px;
                }
            }
            .table-title{
                font-weight: 600;
                FONT-SIZE: 14px;
            }
            .table-user{
                cursor: pointer;
                color: map-get($dark, 800);
                font-weight: 700;
            }
        }
        &__status{
            flex-direction: row;
            span:nth-child(2){
                font-size: 12px;
                font-weight: 400;
                margin-left: 12px;
                @media screen and (max-widht: $bpSmall){
                    font-size: 8px;
                }
            }
        }
        &__lastModification{
            color: map-get($dark, 800)
        }
        &__answered{
            font-size: 12px;
        }

    }
   
.new-feedback{
    width: 100%;
    margin-top: 16px;
    //max-width: 450px;
    h4{
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 500;
        .material-icons{
            font-size: 18px;
        }
    }
    textarea{
        width: 100%;
        height: 80px;
        padding: 6px;
        resize: none;
        border-radius: 4px;
    }
    &__actions{
        padding: 0;
        padding-top: 16px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
        button{
            padding: 12px 28px;
            border-radius: 44px;
            color: $green;
            font-weight: 600;
            font-size: 14px;
            display: flex;
            align-items: center;
            gap: 6px;
            .material-icons-outlined{
                font-size: 14px;
            }
            &.confirm{
                background: $green;
                color: #fff;
            }
        }
        }
    }
}

/*.sendAttach--effect{
    animation-name: scale;
    animation-duration: 3s;
    animation-iteration-count: 1;
    
}

 .sendAttach--effect::after{
    position: absolute;
    top: 0;
    left: 0%;
    width: 100%;
    height: 100%;
    transform: translateX(-100%);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(37, 22, 22, 0));
    animation: slide 4.5s infinite;
    content: '';
}

@keyframes scale {
    50%{
        transform: scale(1.2);
    }

    100%{
        transform: scale(1)
    }
}

@keyframes slide {
    50%{
        left: 200%;
    }
    100%{
        left:0%;
    }
} */


.dropdown__items{
    background-color: #ffF;
    border-radius: 12px;
}

@media screen and (max-width: $bpBig){
    .attach__date{
        font-size: 13px;
    }

    .attaches__container{
        flex-direction: column;
        align-items: flex-start;
        overflow-y: auto;
    }
    .attach__actions{
        margin-top: 36px;
        gap: 16px;
    }
    .info-changes{
        font-size: 12px;
    }

    .feedback__history--btn{
        font-size: 12px;
    }

    .btn-confirm{
        width: 144px;
    }

    .last-submission > div > div{
        flex-direction: column;
        gap: 10px;
        span{
            align-self: flex-start;
        }
    }

    .tutor-view{
        .resume-data{
            grid-template-columns: auto;
            @media screen and (max-widht: $bpSmall){
                font-size: 11px;
            }
        }
        .detail-data{
            grid-template-columns: 30px minmax(115px, 200px) minmax(max-content, 290px) auto auto;
        }
    }

    .NotFinished{
    &--a{
        font-size: 12px;
    }
    }
    .FinishedOutOfTime{
        &--a{
            font-size: 12px;
        }
    }
    .FinishedInTime{
        &--a{
            font-size: 12px;
        }
    }

    .tutor-view .detail__status span:nth-child(2){
        margin-left: 18px;
    }
}

.uploadFile-icon{
    color: #fff;
    padding: 18px;
    background-color: #54C5C5;
    border-radius: 1000px;
    font-size: 24px;
}

input:disabled{
    opacity: .4;
    cursor: default;
}

.disabled{
    opacity: .4;
    cursor: default;
}
</style>